import styled, { css } from 'styled-components';

import { media } from '@theme/media';
import { COLORS } from '@theme/colors';

const inputStyles = css`
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;
  padding: 12px 10px 11px;
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;

  ${media.mobile} {
    font-size: 13px;
    letter-spacing: 0.02em;
  }

  ${media.tablet} {
    padding: 8px 13px 7px;
  }

  &::placeholder {
    ${media.mobile} {
      opacity: 0;
    }
  }
`;
export const Input = styled.input`
  ${inputStyles};
`;

export const Textarea = styled.textarea`
  ${inputStyles};
  min-height: 102px;
  resize: none;
`;

export const TextAreaOptional = styled.div`
  color: ${COLORS.BLACK30};
`;

export const Label = styled.label`
  min-width: 136px;
  font-size: 13px;
  line-height: 18px;
  padding: 10px 13px 7px;
  display: none;
  white-space: nowrap;

  ${media.mobile} {
    display: block;
  }
`;

export const InputWrapper = styled.div`
  background-color: ${COLORS.WILD_SAND};
  position: relative;

  margin-bottom: 17px;
  display: flex;
  flex-direction: row;
  justify-content: center;

  &:focus-within {
    background-color: ${COLORS.MERCURY};
  }
`;
